import register from '@kpsys/angularjs-register';
import messagesRoutes from './messages.routes';
import KpMessageSendingComponent from './kp-message-sending/kp-message-sending.component';
import KpMessageSendingSmsComponent from './kp-message-sending-sms/kp-message-sending-sms.component';
import KpMessageSendingPostComponent from './kp-message-sending-post/kp-message-sending-post.component';
import KpMessageSendingEmailComponent from './kp-message-sending-email/kp-message-sending-email.component';
import KpMessageSendingInternalComponent from './kp-message-sending-internal/kp-message-sending-internal.component';

/**
 * @ngdoc module
 * @name uc.messages
 * @module uc.messages
 *
 * @description
 * Messages UC
 */

export default register('uc.messages')
    .config(messagesRoutes)
    .component(KpMessageSendingComponent.componentName, KpMessageSendingComponent)
    .component(KpMessageSendingSmsComponent.componentName, KpMessageSendingSmsComponent)
    .component(KpMessageSendingPostComponent.componentName, KpMessageSendingPostComponent)
    .component(KpMessageSendingEmailComponent.componentName, KpMessageSendingEmailComponent)
    .component(KpMessageSendingInternalComponent.componentName, KpMessageSendingInternalComponent)
    .name();
